export default __webpack_public_path__ + "static/media/rajma.67fd7dea.png";